import type { Verse } from '../types/bible';

export function getVerseKey(verse: Verse): string {
  return `${verse.book}-${verse.chapter}-${verse.verse}`;
}

export function parseVerseKey(key: string): Verse {
  const [book, chapter, verse] = key.split('-');
  return { book, chapter, verse };
}

export function expandVerseRange(verse: string): string[] {
  const parts = verse.split('-');
  if (parts.length === 1) return [verse];
  
  const start = parseInt(parts[0]);
  const end = parseInt(parts[1]);
  
  const verses: string[] = [];
  for (let i = start; i <= end; i++) {
    verses.push(i.toString());
  }
  return verses;
}
